export default __webpack_public_path__ + "static/media/quote-mark.562ce564.svg";